import { useEffect, useState } from "react";
import {
  App,
  Cascader,
  Flex,
  Tooltip,
  Typography,
} from "antd";

import { PriceHis } from "@/types/sales";
import { ProductPrice } from "@/types/product";
import { productPrice } from "@/apis/product";
import { getSupplierName } from "@/utils/supplier";

const { Text } = Typography;

type SelectValue = Array<string>;

interface SCurrencySelectProps {
  productId: string;
  value?: SelectValue;
  onChange?: (ids: Array<string>, value: PriceOption | undefined) => void;
  defaultList?: Array<PriceHis>;
  disabled?: boolean;
}

export interface PriceOption {
  label: string;
  value: string;
  code: string;
  address: string;
  price: string;
  mpq: string | null;
  days: number | null;
  spareRate: string;
}

const SelectSupplierPrice = ({
  value,
  onChange,
  productId,
  disabled,
}: SCurrencySelectProps) => {
  const { notification } = App.useApp();

  const [dataList, setDataList] = useState<ProductPrice[]>([])


  const options: Array<PriceOption> = dataList?.map((item) => ({
    label: item.supplier ? getSupplierName(item.supplier) : '',
    value: item.priceId,
    code: item?.supplier?.code || '',
    address: item?.supplier?.address || '',
    price: item.price,
    mpq: item.mpq || null,
    days: item.days || null,
    spareRate: Number(item?.spareRate || '0') + ''
  }));

  useEffect(() => {
    if (productId) {
      productPrice([productId])
        .then(res => setDataList(res))
        .catch(err => setDataList([]))
    }
  }, [productId]);

  const getProductRender = (item: PriceOption) => {
    return <Tooltip
      title={
        <div>
          <div>供应商名称: {item.label}</div>
          <div>供应商编码: {item.code}</div>
          <div>供应商地址: {item.address}</div>
        </div>
      }
    >
      <Flex
        gap={10}
        style={{ width: "100%" }}
        align="center"
        justify="space-between"
      >
        <Text style={{ width: "30%" }} ellipsis>
          {item.label ?? ""}
        </Text>
        <Text style={{ width: "20%" }} ellipsis>
          {item.code ?? ""}
        </Text>
        <Text style={{ width: "50%" }} ellipsis>
          {item?.address ?? ""}
        </Text>
      </Flex>
    </Tooltip>
  }

  return (
    <Cascader
      disabled={disabled}
      value={value}
      options={options}
      optionRender={option => getProductRender(option)}
      onDropdownVisibleChange={(open) => {
        if (open) {
          if (!productId) {
            notification.error({ placement: 'top',
              message: "没有存货信息！",
            });
          }
        }
      }}
      placeholder={"选择供应商"}
      showSearch
      onChange={(val, info) => {
        if (val?.length > 0) {
          const data = { ...info[0] }
          onChange && onChange(val, data);
        } else {
          onChange && onChange([], undefined);
        }
      }}
      style={{ width: "100%" }}
    />
  );
};

export default SelectSupplierPrice;
